import Select from '@components/v2/form/Select/Select';
import TextField from '@components/v2/form/TextField/TextField';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { onlyNumbers } from '../../../../../../utils/validators';
import { OrderAbandonmentSectionGeneralSettingsProps } from '../../../types/GeneralSettings.types';
import {
  InactivityBlockConfigKeys,
  InactivityBlockConfigLabels,
  InactivityConfigItems,
} from '../OrderInactivitySectionGeneralSettings.types';

interface InactivityBlockConfigProps extends OrderAbandonmentSectionGeneralSettingsProps {
  items: Array<InactivityConfigItems>;
  keys: InactivityBlockConfigKeys;
  labels: InactivityBlockConfigLabels;
}

const InactivityBlockConfig = ({
  generalSettings,
  items,
  keys,
  labels,
  handleBlur,
  handleChange,
  handleChangeAndBlur,
}: InactivityBlockConfigProps) => {
  const selectValue = (generalSettings[keys.selectName] as string) || '';
  const timeoutValue = generalSettings[keys.timeoutName] as number | null;

  return (
    <Stack spacing={1}>
      <Select
        name={String(keys.selectName)}
        value={selectValue}
        label={labels.selectLabel}
        renderValue={(selected) => items.find((item) => item.value === selected)?.label ?? ''}
        onChange={(event) =>
          handleChangeAndBlur({
            value: (event.target.value as string) || null,
            name: keys.selectName,
          })
        }
      >
        {items.map((item) => (
          <MenuItem
            key={item.value}
            value={item.value}
            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}
          >
            <Typography variant="body1">{item.label}</Typography>
            <Typography variant="body2" color="textSecondary">
              {item.description}
            </Typography>
          </MenuItem>
        ))}
      </Select>
      <TextField
        name={String(keys.timeoutName)}
        value={timeoutValue ?? ''}
        label={labels.inputLabel}
        onBlur={() => handleBlur()}
        slotProps={{
          inputLabel: { shrink: timeoutValue != null },
          htmlInput: { maxLength: 4 },
        }}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
          const value = onlyNumbers(event.target.value);
          handleChange({
            value: value ? Number(value) : null,
            name: keys.timeoutName,
          });
        }}
      />
    </Stack>
  );
};

export default InactivityBlockConfig;
